<template>
  <div style="position: relative">
    <b-sidebar
      id="sidebar-produto-fields"
      title="Informações visíveis"
      backdrop-variant="dark"
      backdrop
      right
      shadow
    >
      <div class="px-2 py-2">
        <div style="width: 100%" class="p-2">
          <h4 class="text-dark">Colunas customizadas</h4>
          <p>
            Selecione abaixo quais colunas deseja que estejam visíveis na
            listagem de produtos
          </p>
        </div>
        <div
          style="width: 100%; max-height: 100%; overflow-y: scroll"
          class="mb-2"
        >
          <div
            v-for="(el, index) in extraFields"
            :key="el.field"
            :label="el.label"
            class="mb-0 ml-5"
          >
            <div
              v-if="el.field !== 'actions'"
              style="display: flex; align-items: center; gap: 10px"
            >
              <span class="switch switch-icon">
                <label>
                  <input
                    type="checkbox"
                    @change="
                      (e) =>
                        handleSelectFieldToShow(
                          e.target.checked,
                          el.field,
                          index
                        )
                    "
                    :checked="isFieldShow(el.field)"
                  />
                  <span></span>
                </label>
              </span>
              <label :for="el.label" class="mb-0">{{ el.label }}</label>
            </div>
          </div>
        </div>
      </div>
      <template #footer="{ hide }">
        <div class="d-flex text-light align-items-center px-3 py-2">
          <button
            style="width: 100%"
            ref="salvarFields"
            class="btn btn-primary btn-hover-dark font-weight-bold"
            @click="handleSaveFields"
          >
            Salvar
          </button>
        </div>
      </template>
    </b-sidebar>

    <b-sidebar
      id="sidebar-arquivo-balanca"
      title="Gerar arquivo"
      backdrop-variant="dark"
      backdrop
      right
      shadow
    >
      <div class="px-2 py-2">
        <div style="width: 100%" class="p-2">
          <h4 class="text-dark">Gerar arquivo</h4>
          <p>Selecione o modelo da balança:</p>
        </div>
        <div
          style="width: 100%; max-height: 100%; overflow-y: scroll"
          class="mb-2"
        >
          <b-col md="12">
            <b-form-group label="Modelo" label-for="modeloBalanca">
              <select
                name="modeloBalanca"
                id="modeloBalanca"
                v-model="modeloBalanca"
                class="form-control"
              >
                <option
                  v-for="(b, index) in balancas"
                  :value="b.id"
                  :key="'modelo' + index"
                >
                  {{ b.descricao }}
                </option>
              </select>
            </b-form-group>
          </b-col>
        </div>
      </div>
      <template #footer="{ hide }">
        <div class="d-flex text-light align-items-center px-3 py-2">
          <button
            style="width: 100%"
            ref="gerarTXT"
            class="btn btn-primary btn-hover-dark font-weight-bold"
            @click="gerarArquivoTxt"
          >
            Gerar
          </button>
        </div>
      </template>
    </b-sidebar>

    <FilterFields
      :fields="[
        {
          type: 'number',
          label: 'Código',
          field: 'codigo',
        },
        {
          type: 'text',
          label: 'Descrição',
          field: 'descricao',
        },
        {
          type: 'text',
          label: 'Fornecedor',
          field: 'fornecedor',
        },
        {
          type: 'text',
          label: 'Grupo',
          field: 'id_grupo',
        },
        {
          type: 'number',
          label: 'Cod. Barras',
          field: 'cod_barras',
        },
        {
          type: 'text',
          label: 'Referência',
          field: 'referencia',
        },
        {
          type: 'number',
          label: 'N. Compra',
          field: 'numero_ultima_compra',
        },
        {
          type: 'number',
          label: 'Custo',
          field: 'custo',
        },
        {
          type: 'number',
          label: 'Preço',
          field: 'preco',
        },
        {
          type: 'text',
          label: 'Obs',
          field: 'obs',
        },
        {
          type: 'text',
          label: 'Descrição Comple.',
          field: 'desc_complementar',
        },
        {
          type: 'text',
          label: 'Marca',
          field: 'marca',
        },
        {
          type: 'text',
          label: 'Tributação',
          field: 'id_tributacao',
        },
        {
          type: 'select',
          label: 'Tipo',
          field: 'tipo',
          options: [
            'Todos',
            'Mercadoria para Revenda',
            'Matéria-Prima',
            'Embalagem',
            'Produto em processo',
            'Produto Acabado',
            'Subproduto',
            'Material uso e consumo',
            'Ativo Imobilizado',
            'Outros',
          ],
        },
        {
          type: 'select',
          label: 'Status',
          field: 'status',
          options: ['Ativo', 'Inativo'],
        },
        {
          type: 'select',
          label: 'Quantidade',
          field: 'quantidade',
          options: ['Negativos', 'Positivos', 'Zerados'],
        },
      ]"
    />

    <b-dropdown
      id="menu"
      variant="dark"
      v-b-tooltip.right="'Mais ações'"
      style="position: absolute; top: 0; left: 50px"
    >
      <template #button-content>
        <Menu :size="18" />
      </template>
      <b-dropdown-item
        v-b-modal.duplicarProduto
        :disabled="
          !actionsStore.selectedRows.length ||
          actionsStore.selectedRows.length > 1
        "
        >Duplicar produto</b-dropdown-item
      >
      <b-dropdown-item
        @click="
          () =>
            getRequestAdmin(() => {
              $bvModal.show('excluirProdutos');
            })
        "
        :disabled="!actionsStore.selectedRows.length"
        >Excluir produto(s)
      </b-dropdown-item>
      <b-dropdown-item
        @click="
          () =>
            getRequestAdmin(() => {
              $bvModal.show('reajustePreco');
            })
        "
        >Reajuste de Preço
      </b-dropdown-item>
      <b-dropdown-item
        @click="
          () =>
            getRequestAdmin(() => {
              abrirModalReplicarCampo();
            })
        "
        >Manutenção de produtos
      </b-dropdown-item>
      <b-dropdown-item
        @click="
          () =>
            getRequestAdmin(() => {
              $bvModal.show('produtosPesados');
            })
        "
        >Gerar código de barras (Produtos Pesados)
      </b-dropdown-item>
    </b-dropdown>

    <b-button
      class="border border-muted"
      v-b-toggle.sidebar-produto-fields
      variant="secondary"
      v-b-tooltip.hover.right="'Customizar colunas'"
      style="position: absolute; right: 0; top: 0"
    >
      <ToggleSwitchOutline :size="20" />
    </b-button>

    <b-button
      class="border border-muted"
      variant="secondary"
      v-b-tooltip.hover.left="'Lista de preço'"
      style="position: absolute; right: 150px; top: 0"
    >
      <router-link
        :to="{
          name: 'lista',
        }"
      >
        <MoneySymbol :size="20" />
      </router-link>
    </b-button>

    <b-button
      class="border border-muted"
      variant="secondary"
      v-b-tooltip.hover.right="'Terminal de consulta'"
      style="position: absolute; right: 50px; top: 0"
    >
      <router-link
        target="_blank"
        :to="{
          name: 'terminalConsulta',
        }"
      >
        <BarcodeScan :size="20" />
      </router-link>
    </b-button>

    <b-button
      class="border border-muted"
      v-b-toggle.sidebar-arquivo-balanca
      variant="secondary"
      v-b-tooltip.hover.right="
        'Gerar arquivo .txt para carga nas balanças (Produtos Pesados)'
      "
      style="position: absolute; right: 100px; top: 0"
    >
      <Balence :size="20" />
    </b-button>

    <b-modal
      id="excluirProdutos"
      title="Deseja excluir todos os produtos selecionados?"
      centered
      size="xs"
    >
      <div class="d-flex">
        <p>
          Somente será possível excluir um produto, se não houver nenhum tipo de
          movimentação para o produto.
        </p>
      </div>
      <template #modal-footer="{ ok, cancel }">
        <div>
          <b-button
            variant="primary"
            @click="excluirProduto"
            ref="excluirProdutos"
            class="mr-5"
          >
            Excluir
          </b-button>
          <b-button
            @click="
              {
                actionsStore.updateTable = !actionsStore.updateTable;
                actionsStore.selectedRows = [];
                cancel();
              }
            "
          >
            Cancelar
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-modal
      id="produtosPesados"
      title="Deseja gerar para todos produtos pesados do seu estoque o código de barras?"
      centered
      size="xs"
    >
      <template #modal-footer="{ ok, cancel }">
        <div>
          <b-button
            variant="primary"
            @click="gerarCodigoBarraPesado"
            ref="gerarCodigoBarra"
            class="mr-5"
          >
            Gerar
          </b-button>
          <b-button
            @click="
              {
                actionsStore.updateTable = !actionsStore.updateTable;
                actionsStore.selectedRows = [];
                cancel();
              }
            "
          >
            Cancelar
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-modal
      id="reajustePreco"
      title="Ajuste de preço com base no percentual (%) informado"
      centered
      size="xs"
    >
      <div>
        <b-col md="6">
          <b-form-group
            label="Informe o percentual do reajuste %"
            label-for="percentual"
          >
            <money
              class="form-control"
              v-model="percentual"
              v-bind="configMoney"
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            id="pesado"
            label-for="pesado"
            label="Estoque Total"
            v-b-tooltip.hover.bottom="
              'Marcar para aplicar o reajuste para todo o estoque, caso marcar essa opção vai atualizar todo seu estoque'
            "
          >
            <span class="switch switch-icon">
              <label>
                <input
                  type="checkbox"
                  :value="false"
                  @change="setEstoqueTotal"
                  :checked="estoque_total == true"
                />
                <span></span>
              </label>
            </span>
          </b-form-group>
        </b-col>
      </div>
      <template #modal-footer="{ ok, cancel }">
        <div>
          <b-button
            variant="primary"
            @click="ajustaPreco"
            ref="reajustePreco"
            class="mr-5"
          >
            Ajustar preço(s)
          </b-button>
          <b-button
            @click="
              {
                actionsStore.updateTable = !actionsStore.updateTable;
                actionsStore.selectedRows = [];
                cancel();
              }
            "
          >
            Cancelar
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-modal
      id="duplicarProduto"
      title="Deseja duplicar o produto selecionado?"
      centered
      size="xs"
    >
      <label
        >Produto a ser duplicado:
        <p>{{ actionsStore.selectedRows[0]?.descricao }}</p>
      </label>
      <b-form-group label="Nova descrição" label-for="newDescriptionProduct">
        <b-form-input v-model="newProductDescription" />
      </b-form-group>
      <template #modal-footer="{ ok, cancel }">
        <div>
          <b-button
            variant="primary"
            @click="duplicarProduto"
            ref="doubleProduct"
            class="mr-5"
          >
            Confirmar
          </b-button>
          <b-button
            @click="
              {
                actionsStore.updateTable = !actionsStore.updateTable;
                actionsStore.selectedRows = [];
                cancel();
              }
            "
          >
            Cancelar
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-modal
      id="replicarCampoMassa"
      title="Manutenção de produtos - Atualizar campo em massa"
      centered
      size="xl"
    >
      <!-- Modo de seleção -->
      <div class="row mb-4">
        <b-col md="12">
          <b-form-group label="Modo de atualização:">
            <b-form-radio-group v-model="modoReplicacao" :options="[
              { value: 'selecionados', text: 'Apenas produtos selecionados' },
              { value: 'todos', text: 'Todos os produtos (Estoque Total)' }
            ]" class="font-weight-bold"></b-form-radio-group>
          </b-form-group>
        </b-col>
      </div>

      <!-- Info do modo selecionado -->
      <div class="row" v-if="modoReplicacao === 'selecionados'">
        <b-col md="12">
          <b-alert show variant="info" class="mb-3">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <strong>📌 {{ produtosDestinoReplicacao.length + 1 }} produto(s) selecionado(s)</strong>
              </div>
            </div>
          </b-alert>
          <!-- Lista de produtos selecionados -->
          <div class="border rounded p-3 bg-light mb-3" style="max-height: 150px; overflow-y: auto;">
            <small class="font-weight-bold text-muted d-block mb-2">Produtos que receberão a atualização:</small>
            <div class="small">
              <div v-if="produtoOrigemReplicacao" :key="produtoOrigemReplicacao.id" class="ml-2 mb-1">
                <span class="badge badge-success">{{ produtoOrigemReplicacao.codigo }}</span>
                {{ produtoOrigemReplicacao.descricao }}
              </div>
              <div v-for="prod in produtosDestinoReplicacao" :key="prod.id" class="ml-2 mb-1">
                <span class="badge badge-success">{{ prod.codigo }}</span>
                {{ prod.descricao }}
              </div>
            </div>
          </div>
        </b-col>
      </div>
      <div class="row" v-if="modoReplicacao === 'todos'">
        <b-col md="12">
          <b-alert show variant="warning" class="mb-3">
            <div>
              <strong>⚠️ ATENÇÃO:</strong> Esta operação atualizará <strong>TODOS os produtos</strong> do seu estoque!
            </div>
          </b-alert>
        </b-col>
      </div>

      <hr class="my-4">

      <!-- Seleção do campo -->
      <div class="row">
        <b-col md="12">
          <b-form-group label="Selecione o campo a atualizar:" label-for="campoReplicar">
            <b-form-select
              id="campoReplicar"
              v-model="campoSelecionadoReplicacao"
              :options="camposDisponiveis"
              @change="resetarValorCampoReplicacao"
              placeholder="Escolha um campo..."
            ></b-form-select>
          </b-form-group>
        </b-col>
      </div>

      <!-- Campo de entrada simples (número/texto) -->
      <div class="row" v-if="campoSelecionadoReplicacao && !ehCampoComLooku()">
        <b-col md="12">
          <b-form-group label="Novo valor:" label-for="valorCampo">
            <b-form-input
              id="valorCampo"
              v-model="valorCampoReplicacao"
              :type="obterTipoCampo()"
              placeholder="Digite o novo valor"
              autofocus
            ></b-form-input>
          </b-form-group>
        </b-col>
      </div>

      <!-- Campo com busca (lookup) -->
      <div class="row" v-if="campoSelecionadoReplicacao && ehCampoComLooku()">
        <b-col md="12">
          <b-form-group label="Selecione o valor:" label-for="valorLookup">
            <VueSelect
              id="valorLookup"
              placeholder="Digite para buscar..."
              label="label"
              :filterable="false"
              @input="setSelecionadoItem"
              :options="resultadosLookup"
              @search="handleSearchDinamico"
              v-model="selecionadoItem"
              :clearable="true"
            >
              <template slot="no-options">
                <div class="text-center p-2">
                  <small class="text-muted">Digite para buscar...</small>
                </div>
              </template>
              <template slot="option" slot-scope="option">
                <div class="d-flex justify-content-between">
                  <strong>{{ option.label }}</strong>
                  <small class="text-muted ml-2">ID: {{ option.value }}</small>
                </div>
              </template>
              <template slot="selected-option" slot-scope="option">
                <div class="selected d-center">
                  {{ option.label }}
                </div>
              </template>
            </VueSelect>
          </b-form-group>
          <div v-if="selecionadoItem && selecionadoItem.label" class="alert alert-success small mt-2 mb-0">
            ✅ Selecionado: <strong>{{ selecionadoItem.label }}</strong>
          </div>
        </b-col>
      </div>

      <template #modal-footer="{ ok, cancel }">
        <div>
          <b-button
            variant="primary"
            @click="executarReplicacaoCampo"
            ref="replicarCampoMassaBtn"
            :disabled="!campoSelecionadoReplicacao || !validarValorCampo()"
            class="mr-5"
          >
            Executar Atualização
          </b-button>
          <b-button @click="fecharModalReplicacao">
            Cancelar
          </b-button>
        </div>
      </template>
    </b-modal>

    <TableApp
      titulo="Cadastro de Produtos"
      acaoBtn="/#/produtos/novo"
      textoBtn="Novo"
      api-url="/produtos/filter"
      :fields="fieldsToShow"
      classFilterColumn="produto"
      ref="produto"
      :perPage="10"
      :multiselect="true"
    >
      <template slot="customRow" scope="props">
        <span slot="codigo" v-if="props.field == 'codigo'">
          <span class="pl-0 pt-8">
            <div class="d-flex align-items-center">
              <div>
                <a
                  class="text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg"
                  >{{ props.rowData.codigo }}</a
                >
                <b-card-img
                  v-b-modal.view-product-imagem
                  :src="props.rowData.imagem"
                  class="rounded-0 ml-5"
                  style="width: 50px"
                  @click="
                    () => {
                      produtoToView = props.rowData.imagem;
                    }
                  "
                />
              </div>
            </div>
          </span>
        </span>
        <span slot="referencia" v-if="props.field == 'referencia'">
          <span class="pl-0 pt-8">
            <div class="d-flex align-items-center">
              <div>
                <a
                  class="text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg"
                  >{{ props.rowData.referencia }}</a
                >
              </div>
            </div>
          </span>
        </span>
        <span slot="descricao" v-if="props.field == 'descricao'">
          <span class="pl-0 pt-8">
            <div class="d-flex align-items-center">
              <div>
                <a
                  class="text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg"
                  >{{ props.rowData.descricao.substr(0, 50) }}</a
                >
                <span
                  class="text-muted font-weight-bold d-block"
                  v-if="props.rowData.desc_complementar"
                  >{{ props.rowData.desc_complementar }}</span
                >
              </div>
            </div>
          </span>
        </span>
        <span slot="fornecedor" v-if="props.field == 'fornecedor'">
          <span class="pl-0 pt-8">
            <div class="d-flex align-items-center">
              <div class="font-weight-bold">
                {{ props.rowData.fornecedor }}
              </div>
            </div>
          </span>
        </span>
        <span slot="marca" v-if="props.field == 'marca'">
          <span class="pl-0 pt-8">
            <div class="d-flex align-items-center">
              <div class="font-weight-bold">
                {{ props.rowData.marca }}
              </div>
            </div>
          </span>
        </span>
        <span slot="unidade_medida" v-if="props.field == 'unidade_medida'">
          <div class="font-weight-bold">
            {{ props.rowData.unidade_medida }}
          </div>
        </span>
        <span slot="custo" v-if="props.field == 'custo'">
          <div class="font-weight-bold">
            R$ {{ numberToReal(props.rowData.custo, "preco") }}
          </div>
        </span>
        <span slot="preco" v-if="props.field == 'preco'">
          <div class="font-weight-bold">
            R$ {{ numberToReal(props.rowData.preco, "preco") }}
          </div>
        </span>
        <span slot="quantidade" v-if="props.field == 'quantidade'">
          <div class="font-weight-bold">
            {{ numberToReal(props.rowData.quantidade, "quantidade") }}
          </div>
        </span>
        <span slot="preco_atacado" v-if="props.field == 'preco_atacado'">
          <div class="font-weight-bold">
            {{ numberToReal(props.rowData.preco_atacado, "preco_atacado") }}
          </div>
        </span>
        <span
          slot="quantidade_atacado"
          v-if="props.field == 'quantidade_atacado'"
        >
          <div class="font-weight-bold">
            {{
              numberToReal(
                props.rowData.quantidade_atacado,
                "quantidade_atacado"
              )
            }}
          </div>
        </span>
        <span slot="estoque_minimo" v-if="props.field == 'estoque_minimo'">
          <div class="font-weight-bold">
            {{ numberToReal(props.rowData.estoque_minimo, "estoque_minimo") }}
          </div>
        </span>
        <span slot="cod_barras" v-if="props.field == 'cod_barras'">
          <div class="font-weight-bold">
            {{ props.rowData.cod_barras }}
          </div>
        </span>
        <span slot="ncm" v-if="props.field == 'ncm'">
          <div class="font-weight-bold">
            {{ props.rowData.ncm }}
          </div>
        </span>
        <span slot="tributacao" v-if="props.field == 'tributacao'">
          <div class="font-weight-bold">
            {{ props.rowData.tributacao }}
          </div>
        </span>
        <span slot="tipo_produto" v-if="props.field == 'tipo_produto'">
          <div class="font-weight-bold">
            {{ props.field.tipo_produto }}
          </div>
        </span>
        <span
          class="pl-0 pt-8"
          slot="data_ultima_compra"
          v-if="props.field == 'data_ultima_compra'"
        >
          <div class="d-flex align-items-center">
            <div class="font-weight-bold">
              {{ formatDate(props.rowData.data_ultima_compra) }}
            </div>
          </div>
        </span>
        <span
          class="pl-0 pt-8"
          slot="data_ultima_venda"
          v-if="props.field == 'data_ultima_venda'"
        >
          <div class="d-flex align-items-center">
            <div class="font-weight-bold">
              {{ formatDate(props.rowData.data_ultima_venda) }}
            </div>
          </div>
        </span>
        <span slot="status" v-if="props.field == 'status'">
          <span
            v-if="props.rowData.ativo == true"
            class="label label-lg label-inline label-light-success"
            >Ativo</span
          >
          <span v-else class="label label-lg label-inline label-light-danger"
            >Inativo</span
          >
        </span>
        <span slot="actions" v-if="props.field == 'actions'">
          <div class="row-actions" style="text-align: right !important">
            <span style="overflow: visible; position: relative; width: 130px">
              <div class="dropdown dropdown-inline">
                <router-link
                  class="btn btn-sm btn-info btn-hover-info btn-icon mr-2"
                  v-b-tooltip.hover.bottom="'Editar'"
                  :to="{
                    name: 'produtosUpdate',
                    params: {
                      id_produto: props.rowData.id,
                    },
                  }"
                >
                  <Pencil :size="16" title="Editar" />
                </router-link>
                <button
                  @click="excluir(props.rowData)"
                  class="btn btn-sm btn-danger btn-hover-danger btn-icon mr-2"
                  v-b-tooltip.hover.bottom="'Excluir'"
                >
                  <TrashCanIcon :size="16" />
                </button>
              </div>
            </span>
          </div>
        </span>
      </template>
    </TableApp>

    <b-modal id="view-product-imagem" centered title="Imagem do produto">
      <b-card-img :src="produtoToView" class="rounded-0"></b-card-img>
      <template #modal-footer="{ ok }">
        <div>
          <b-button @click="ok" variant="primary"> Ok </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Pencil from "vue-material-design-icons/Pencil.vue";
import TrashCanIcon from "vue-material-design-icons/TrashCan.vue";
import ToggleSwitchOutline from "vue-material-design-icons/ToggleSwitchOutline.vue";
import BarcodeScan from "vue-material-design-icons/BarcodeScan.vue";
import MoneySymbol from "vue-material-design-icons/CurrencyUsd.vue";
import Balence from "vue-material-design-icons/BatteryCharging.vue";
import TableApp from "@/components/Table/Table2";
import { SistemaMixin } from "@/modules/Application";
import { onboardStore } from "../../../onboardStore";
import FilterFields from "@/components/FilterFields";
import Menu from "vue-material-design-icons/Menu";
import { actionsStore } from "@/components/Table/actionsStore";
import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import swal from "sweetalert";
import { Money } from "v-money";
import { MONEY as settingMoney } from "@/modules/Application";
import _ from "lodash";

export default {
  name: "app-produto",
  mixins: [SistemaMixin],
  components: {
    Pencil,
    TrashCanIcon,
    TableApp,
    FilterFields,
    Menu,
    Money,
    ToggleSwitchOutline,
    BarcodeScan,
    Balence,
    MoneySymbol,
    VueSelect,
  },
  data() {
    return {
      actionsStore,
      onboardStore,
      newProductDescription: null,
      id_configuracao_lista: null,
      selectedFields: [],
      fieldsToShow: [],
      extraFields: [
        {
          index: 9,
          label: "Preço atacado",
          field: "preco_atacado",
          width: "8%",
          sortable: true,
          slot: true,
        },
        {
          index: 10,
          label: "Qtd. atacado",
          field: "quantidade_atacado",
          width: "8%",
          sortable: true,
          slot: true,
        },
        {
          index: 11,
          label: "Cód. de Barra",
          field: "cod_barras",
          width: "8%",
          sortable: false,
          slot: false,
        },
        {
          index: 12,
          label: "Marca",
          field: "marca",
          width: "8%",
          sortable: true,
          slot: true,
        },
        {
          index: 13,
          label: "NCM",
          field: "ncm",
          width: "8%",
          sortable: false,
          slot: true,
        },
        {
          index: 14,
          label: "Dt Última Compra",
          field: "data_ultima_compra",
          width: "8%",
          sortable: true,
          slot: true,
        },
        {
          index: 15,
          label: "Dt Última Venda",
          field: "data_ultima_venda",
          width: "8%",
          sortable: true,
          slot: true,
        },
        {
          index: 16,
          label: "Estoque mínimo",
          field: "estoque_minimo",
          width: "8%",
          sortable: true,
          slot: true,
        },
        {
          index: 17,
          label: "Tributação",
          field: "tributacao",
          width: "8%",
          sortable: false,
          slot: false,
        },
        {
          index: 18,
          label: "Tipo Mercadoria",
          field: "tipo_produto",
          width: "8%",
          sortable: false,
          slot: false,
        },       
        {
          index: 19,
          label: "Grupo",
          field: "grupo",
          width: "8%",
          sortable: false,
          slot: false,
        },
      ],
      produtoToView: null,
      fields: [
        {
          index: 0,
          label: "Código",
          field: "codigo",
          type: "text",
          slot: true,
          sortable: true,
          width: "5%",
          filterOptions: {
            enabled: false,
            placeholder: "Pesquisar codigo",
          },
        },
        {
          index: 1,
          label: "Referência",
          field: "referencia",
          type: "text",
          slot: true,
          sortable: true,
          width: "5%",
          filterOptions: {
            enabled: false,
            placeholder: "Pesquisar referência",
          },
        },
        {
          index: 2,
          label: "Descrição",
          field: "descricao",
          type: "text",
          slot: true,
          sortable: true,
          width: "30%",
          filterOptions: {
            enabled: false,
            placeholder: "Pesquisar descrição",
          },
        },
        {
          index: 3,
          label: "Fornecedor",
          field: "fornecedor",
          type: "text",
          slot: true,
          sortable: false,
          width: "15%",
          filterOptions: {
            enabled: false,
            placeholder: "Pesquisar nome",
          },
        },
        {
          index: 4,
          label: "UN",
          field: "unidade_medida",
          width: "5%",
          sortable: false,
          slot: true,
          filterOptions: {
            enabled: false,
          },
        },
        {
          index: 5,
          label: "Custo",
          field: "custo",
          width: "8%",
          sortable: true,
          slot: true,
          filterOptions: {
            enabled: false,
          },
        },
        {
          index: 6,
          label: "Preço",
          field: "preco",
          width: "8%",
          sortable: true,
          slot: true,
        },
        {
          index: 7,
          label: "Quantidade",
          field: "quantidade",
          width: "8%",
          sortable: true,
          slot: true,
        },
        {
          index: 98,
          label: "Status",
          field: "status",
          width: "2%",
          sortable: false,
          slot: true,
          filterOptions: {
            enabled: false,
          },
        },
        {
          index: 99,
          label: "Ações",
          field: "actions",
          sortable: false,
          slot: true,
          width: "15%",
          filterOptions: {
            enabled: false,
          },
        },
      ],
      percentual: 0,
      configMoney: settingMoney,
      estoque_total: false,
      modeloBalanca: null,
      balancas: [
        {
          id: 1,
          descricao: "Padrão MGV (Toledo, Prix)",
        },
      ],
      // Para replicação de campo em massa
      camposDisponiveis: [
        { value: "id_grupo", text: "Grupo do Produto", comLookup: true, tipo: "lookup" },
        { value: "id_pessoa", text: "Fornecedor", comLookup: true, tipo: "lookup" },
        { value: "id_tributacao", text: "Tributação", comLookup: true, tipo: "lookup" },
        { value: "id_tributacao_st", text: "Tributação ST", comLookup: true, tipo: "lookup" },
        { value: "id_medida", text: "Unidade de Medida", comLookup: true, tipo: "lookup" },
        { value: "id_ncm", text: "NCM", comLookup: true, tipo: "lookup" },
        { value: "id_cfop", text: "CFOP NFe", comLookup: true, tipo: "lookup" },
        { value: "id_cfop_nfce", text: "CFOP NFce", comLookup: true, tipo: "lookup" },
        { value: "id_origem", text: "Origem da Mercadoria", comLookup: true, tipo: "lookup" },
        { value: "id_cst_csosn", text: "CST Não Contribuinte", comLookup: true, tipo: "lookup" },
        { value: "id_cst_csosn_contribuinte", text: "CST Contribuinte", comLookup: true, tipo: "lookup" },
        { value: "id_cest", text: "Código CEST", comLookup: true, tipo: "lookup" },
        { value: "custo", text: "Custo Unitário", comLookup: false, tipo: "number" },
        { value: "preco", text: "Preço de Venda", comLookup: false, tipo: "number" },
        { value: "preco_atacado", text: "Preço Atacado", comLookup: false, tipo: "number" },
        { value: "quantidade_atacado", text: "Quantidade Atacado", comLookup: false, tipo: "number" },
        { value: "estoque_minimo", text: "Estoque Mínimo", comLookup: false, tipo: "number" },
        { value: "ipi", text: "% IPI", comLookup: false, tipo: "number" },
        { value: "pis", text: "% PIS", comLookup: false, tipo: "number" },
        { value: "cofins", text: "% COFINS", comLookup: false, tipo: "number" },
        { value: "mva", text: "% MVA", comLookup: false, tipo: "number" },
      ],
      modoReplicacao: "selecionados", // "selecionados" ou "todos"
      campoSelecionadoReplicacao: null,
      valorCampoReplicacao: null, // Para inputs normais
      produtoOrigemReplicacao: null,
      produtosDestinoReplicacao: [],
      // Para campos com lookup
      resultadosLookup: [],
      selecionadoItem: null,
      // Origens da mercadoria (lista estática)
      origens: [
        {
          id: 0,
          descricao: "0 - Nacional, exceto as indicadas nos códigos 3 a 5",
        },
        {
          id: 1,
          descricao:
            "1 - Estrangeira - Importação direta, exceto a indicada no código 6",
        },
        {
          id: 2,
          descricao:
            "2 - Estrangeira - Adquirida no mercado interno, exceto a indicada no código 7",
        },
        {
          id: 3,
          descricao:
            "3 - Nacional, mercadoria ou bem com Conteúdo de Importação superior a 40%",
        },
        {
          id: 4,
          descricao:
            "4 - Nacional, cuja produção tenha sido feita em conformidade com os processos produtivos básicos de que tratam o Decreto-Lei nº 288/1967.",
        },
        {
          id: 5,
          descricao:
            "5 - Nacional, mercadoria ou bem com Conteúdo de Importação inferior ou igual a 40%",
        },
        {
          id: 6,
          descricao:
            "6 - Estrangeira - Importação direta, sem similar nacional, constante em lista de Resolução Camex e gás natural",
        },
        {
          id: 7,
          descricao:
            "7 - Estrangeira - Adquirida no mercado interno, sem similar nacional, constante em lista de Resolução Camex e gás natural",
        },
        {
          id: 8,
          descricao:
            "8 – Nacional: mercadoria ou bem com Conteúdo de Importação superior a 70%;",
        },
      ],
    };
  },
  async created() {
    this.fieldsToShow = _.cloneDeep(this.fields);
    this.selectedFields = _.cloneDeep(this.fields);
    try {
      const { data } = await this.$http.post("/configuracao-lista/find", {
        modulo: 1,
      });
      this.id_configuracao_lista = data?.id_configuracao_lista ?? null;
      if (data.lista.length > 0) {
        this.fieldsToShow = _.cloneDeep(data.lista);
        this.selectedFields = _.cloneDeep(data.lista);
      }
    } catch (error) {
      console.log(error);
    }
  },
  methods: {
    isFieldShow(field) {
      return !!this.fieldsToShow.find((el) => el.field === field);
    },
    handleSelectFieldToShow(value, field, index) {
      if (value) {
        const fieldToAdd = this.extraFields.find((el) => el.field === field);
        const aux = _.cloneDeep(this.selectedFields);
        aux.push(fieldToAdd);
        this.selectedFields = aux.sort((a, b) =>
          a?.index < b?.index ? -1 : 1
        );
      } else
        this.selectedFields = this.selectedFields
          .filter((el) => el.field !== field)
          .sort((a, b) => (a.index < b.index ? -1 : 1));
    },
    async gerarArquivoTxt() {
      this.addLoadingToButton("gerarTXT");
      try {
        const { data } = await this.$http.post(
          "/produtos/gerar-arquiv-balanca",
          {
            modelo: this.modeloBalanca,
          }
        );

        if (data) {
          window.open(data["url_file"], "_blank");
        }
        this.$toast.success("Arquivo gerado com sucesso!");
      } catch (error) {
        console.log(error);
      }
      this.removeLoadingToButton("gerarTXT");
      this.$root.$emit("bv::toggle::collapse", "sidebar-arquivo-balanca");
    },
    async handleSaveFields() {
      this.addLoadingToButton("salvarFields");
      try {
        const { data } = await this.$http.post(
          this.id_configuracao_lista
            ? "/configuracao-lista/update"
            : "/configuracao-lista/create",
          {
            ...(this.id_configuracao_lista && {
              id_configuracao_lista: this.id_configuracao_lista,
            }),
            modulo: 1,
            lista: this.selectedFields,
          }
        );
        this.$toast.success(data.msg);
        this.fieldsToShow = [...this.selectedFields];
        if (!this.id_configuracao_lista)
          this.id_configuracao_lista = data.data.id_configuracao_lista;
      } catch (error) {
        console.log(error);
      }
      this.removeLoadingToButton("salvarFields");
      this.$root.$emit("bv::toggle::collapse", "sidebar-produto-fields");
    },
    async duplicarProduto() {
      const id_produto = this.actionsStore?.selectedRows[0]?.id;
      this.addLoadingToButton("doubleProduct");
      if (!id_produto) {
        this.$toast.error("Produto sem id válido!");
        this.removeLoadingToButton("doubleProduct");
        return;
      }
      if (!this.newProductDescription) {
        this.$toast.error("Nova descrição obrigatória!");
        this.removeLoadingToButton("doubleProduct");
        return;
      }
      try {
        await this.$http.post("/produtos/duplicar", {
          id_produto,
          descricao: this.newProductDescription,
        });
        this.actionsStore.updateTable = !this.actionsStore.updateTable;
        this.$toast.success("Produto duplicado com sucesso!");
        this.$refs.produto.refresh();
        this.newProductDescription = null;
        this.$bvModal.hide("duplicarProduto");
      } catch (error) {
        console.log(error);
      }
      this.removeLoadingToButton("doubleProduct");
    },
    async excluirProduto() {
      this.addLoadingToButton("excluirProdutos");
      try {
        await this.$http
          .post("/produtos/delete-all", {
            produtos: this.actionsStore.selectedRows.map((produto) => ({
              id: produto.id,
            })),
          })
          .then((result) => {
            this.actionsStore.selectedRows = [];
            this.actionsStore.updateTable = !this.actionsStore.updateTable;
            this.$toast.success("Solicitação realizada com sucesso!");
            this.$refs.produto.refresh();
            this.$bvModal.hide("menuAcoes");
            this.$bvModal.hide("excluirProdutos");
            swal.stopLoading();
            swal.close();
          })
          .catch(() => {
            swal.stopLoading();
            swal.close();
          });
        this.actionsStore.selectedRows = [];
        this.actionsStore.updateTable = !this.actionsStore.updateTable;
        this.$bvModal.hide("menuAcoes");
        this.$bvModal.hide("excluirProdutos");
      } catch (error) {
        this.$bvModal.hide("excluirProdutos");
      }
      this.removeLoadingToButton("excluirProdutos");
    },
    excluir(data) {
      this.getRequestAdmin(() => {
        this.$swal
          .fire({
            icon: "warning",
            title: "Excluir o Produto " + data.descricao + "?",
            showCancelButton: true,
            confirmButtonText: `Sim`,
            cancelButtonText: `Não`,
            confirmButtonColor: "#f64e60",
          })
          .then(async (result) => {
            if (result.isConfirmed) {
              await this.$http.post("/produtos/delete", {
                id: data.id,
              });
              this.$refs.produto.refresh();
              this.$toast.success("Produto excluído!");
            }
          });
      });
    },
    setEstoqueTotal() {
      this.estoque_total = this.estoque_total == true ? false : true;
    },
    async gerarCodigoBarraPesado() {
      this.addLoadingToButton("gerarCodigoBarra");
      try {
        await this.$http.post("/produtos/gerar-barra-pesados");
        this.actionsStore.updateTable = !this.actionsStore.updateTable;
        this.$toast.success("Código de barras gerado com sucesso!");
        this.$refs.produto.refresh();
        this.actionsStore.selectedRows = [];
        this.$bvModal.hide("produtosPesados");
      } catch (error) {
        console.log(error);
      }
      this.removeLoadingToButton("gerarCodigoBarra");
    },
    async ajustaPreco() {
      this.addLoadingToButton("reajustePreco");
      if (!this.percentual) {
        this.$toast.error("Informe o percentual!");
        this.removeLoadingToButton("reajustePreco");
        return;
      }
      try {
        await this.$http.post("/produtos/ajuste-preco", {
          produtos: this.actionsStore.selectedRows.map((produto) => ({
            id_produto: produto.id,
          })),
          estoque_total: this.estoque_total,
          percentual: this.percentual,
        });
        this.actionsStore.updateTable = !this.actionsStore.updateTable;
        this.$toast.success("Ajuste aplicado com sucesso!");
        this.$refs.produto.refresh();
        this.percentual = 0;
        this.estoque_total = false;
        this.actionsStore.selectedRows = [];
        this.$bvModal.hide("reajustePreco");
      } catch (error) {
        this.percentual = 0;
        this.estoque_total = false;
        console.log(error);
      }
      this.removeLoadingToButton("reajustePreco");
    },
    ehCampoComLooku() {
      if (!this.campoSelecionadoReplicacao) return false;
      const campo = this.camposDisponiveis.find(c => c.value === this.campoSelecionadoReplicacao);
      return campo?.comLookup === true;
    },
    obterTipoCampo() {
      if (!this.campoSelecionadoReplicacao) return "text";
      const campo = this.camposDisponiveis.find(c => c.value === this.campoSelecionadoReplicacao);
      return campo?.tipo === "number" ? "number" : "text";
    },
    abrirModalReplicarCampo() {
      // Modo 1: Estoque total (aplica para todos)
      if (this.modoReplicacao === "todos") {
        this.produtoOrigemReplicacao = null;
        this.produtosDestinoReplicacao = [];
        this.campoSelecionadoReplicacao = null;
        this.valorCampoReplicacao = null;
        this.$bvModal.show("replicarCampoMassa");
        return;
      }

      // Modo 2: Produtos selecionados
      if (!this.actionsStore.selectedRows || this.actionsStore.selectedRows.length < 1) {
        this.$toast.error("Selecione pelo menos 1 produto!");
        return;
      }

      // Se tiver 1+ produtos selecionados, abre modal
      this.produtoOrigemReplicacao = this.actionsStore.selectedRows[0];
      this.produtosDestinoReplicacao = this.actionsStore.selectedRows.slice(1);
      this.campoSelecionadoReplicacao = null;
      this.valorCampoReplicacao = null;
      this.searchLookupValue = "";
      this.resultadosLookup = [];
      this.selecionadoItem = null;

      this.$bvModal.show("replicarCampoMassa");
    },
    resetarValorCampoReplicacao() {
      this.valorCampoReplicacao = null;
      this.resultadosLookup = [];
      this.selecionadoItem = null;
    },
    setSelecionadoItem(item) {
      this.selecionadoItem = item;
    },
    
    // Obtém o ID correto baseado no campo e estrutura do item
    obterIdDoItem(item, campo) {
      if (!item) return null;
      
      // Mapeamento customizado por campo
      switch(campo) {
        case "id_pessoa":
          return item.id_pessoa || item.id;
        case "id_grupo":
          return item.id_grupo || item.id;
        case "id_tributacao":
        case "id_tributacao_st":
          return item.id_tributacao || item.id;
        case "id_medida":
          return item.id_medida || item.id;
        case "id_ncm":
          return item.id_ncm || item.id;
        case "id_origem":
          return item.id_origem || item.id;
        case "id_cfop":
        case "id_cfop_nfce":
          return item.id_cfop || item.id;
        case "id_cest":
          return item.id_cest || item.id;
        case "id_cst_csosn":
        case "id_cst_csosn_contribuinte":
          return item.id_cst_csosn || item.id_cst || item.codigo || item.id;
        default:
          return item.id || item.id_pessoa || item.codigo;
      }
    },
    
    handleSearchDinamico(search, loading) {
      if (!this.campoSelecionadoReplicacao || search.length < 2) {
        this.resultadosLookup = [];
        if (loading) loading(false);
        return;
      }

      if (loading) loading(true);
      this.executarBuscaDinamica(search, loading);
    },

    // Executa a busca com base no campo selecionado
    executarBuscaDinamica: _.debounce(async function(search, loading) {
      try {
        const campo = this.campoSelecionadoReplicacao;
        let dados = [];

        switch(campo) {
          case "id_grupo":
            dados = await this.getGrupoByDescricao(search);
            break;
          case "id_pessoa":
            dados = await this.getFornecedorByNome(search);
            break;
          case "id_tributacao":
          case "id_tributacao_st":
            dados = await this.getTributacaoByDescricao(search);
            break;
          case "id_medida":
            dados = await this.getUNByDescricao(search);
            break;
          case "id_ncm": {
            const allNCM = await this.getNCM();
            dados = Array.isArray(allNCM) ? allNCM.filter(item => {
              const label = (item.codigo || item.descricao || '').toString().toLowerCase();
              return label.includes(search.toLowerCase());
            }) : [];
            break;
          }
          case "id_origem": {
            // Usar lista estática e filtrar localmente
            const searchLower = String(search).toLowerCase().trim();
            dados = this.origens.filter(item => {
              const descricao = String(item.descricao).toLowerCase();
              const id = String(item.id);
              return descricao.includes(searchLower) || id.includes(searchLower);
            });
            break;
          }
          case "id_anp":
            dados = await this.getAnpByCodigo(search);
            break;
          case "id_cenq":
            dados = await this.getCenqByCodigo(search);
            break;
          case "id_cest":
            dados = await this.getCESTByCodigo(search);
            break;
          case "id_cfop":
          case "id_cfop_nfce":
            dados = await this.getCFOPByCodigo(search);
            break;
          case "id_cst_csosn":
          case "id_cst_csosn_contribuinte": {
            dados = await this.getCstCsosn();
            // Filtrar localmente para CST
            dados = dados.filter(item => {
              const label = item.codigo || item.descricao || JSON.stringify(item);
              return label.toLowerCase().includes(search.toLowerCase());
            });
            break;
          }
          default:
            dados = [];
        }

        // Mapear para formato esperado pelo v-select
        this.resultadosLookup = (Array.isArray(dados) ? dados : []).map(item => {
          let label;
          
          // Formatar label específico por tipo de campo
          if (this.campoSelecionadoReplicacao === "id_cst_csosn" || 
              this.campoSelecionadoReplicacao === "id_cst_csosn_contribuinte" ||
              this.campoSelecionadoReplicacao === "id_cest" ||
              this.campoSelecionadoReplicacao === "id_cfop" ||
              this.campoSelecionadoReplicacao === "id_cfop_nfce") {
            label = item.codigo ? `${item.codigo} - ${item.descricao}` : item.descricao;
          } else {
            label = item.descricao || item.nome || item.codigo || JSON.stringify(item);
          }
          
          return {
            value: this.obterIdDoItem(item, this.campoSelecionadoReplicacao),
            label: label,
            ...item
          };
        });

      } catch (error) {
        console.log("Erro ao buscar:", error);
        this.resultadosLookup = [];
      }

      if (loading) loading(false);
    }, 350),
    validarValorCampo() {
      if (!this.campoSelecionadoReplicacao) return false;
      
      // Para campos com lookup, precisa ter item selecionado
      if (this.ehCampoComLooku()) {
        return this.selecionadoItem !== null;
      }
      
      // Para campos normais, precisa ter valor
      return this.valorCampoReplicacao !== null && this.valorCampoReplicacao !== "";
    },
    async executarReplicacaoCampo() {
      if (!this.campoSelecionadoReplicacao) {
        this.$toast.error("Selecione um campo válido!");
        return;
      }

      // Validar modo e seleção
      if (this.modoReplicacao === "selecionados" && this.produtosDestinoReplicacao.length === 0 && this.produtoOrigemReplicacao === null) {
        this.$toast.error("Selecione ao menos 1 produto!");
        return;
      }

      // Obter valor a replicar
      let valor;
      if (this.ehCampoComLooku()) {
        if (!this.selecionadoItem) {
          this.$toast.error("Selecione um valor do campo!");
          return;
        }
        valor = this.selecionadoItem.value;
      } else {
        if (!this.valorCampoReplicacao) {
          this.$toast.error("Digite um valor!");
          return;
        }
        valor = this.valorCampoReplicacao;
      }

      this.addLoadingToButton("replicarCampoMassaBtn");

      try {
        // Preparar payload com todos os produtos selecionados
        let produtos = [];
        if (this.modoReplicacao === "selecionados") {
          // Incluir origem + destinos
          if (this.produtoOrigemReplicacao) {
            produtos.push({ id_produto: this.produtoOrigemReplicacao.id });
          }
          produtos = produtos.concat(
            this.produtosDestinoReplicacao.map((prod) => ({ id_produto: prod.id }))
          );
        }

        let payload = {
          campo: this.campoSelecionadoReplicacao,
          valor: valor,
          estoque_total: this.modoReplicacao === "todos",
          produtos: produtos
        };

        const { data } = await this.$http.post("/produtos/atualizar-em-massa", payload);

        const qtd = this.modoReplicacao === "todos" 
          ? "todos os produtos" 
          : `${produtos.length} produto(s)`;
        
        this.$toast.success(data.message || `Campo atualizado em ${qtd}!`);
        
        // Atualizar tabela
        this.actionsStore.updateTable = !this.actionsStore.updateTable;
        this.$refs.produto.refresh();
        
        // Limpar e fechar
        this.fecharModalReplicacao();
      } catch (error) {
        console.log(error);
        this.$toast.error(
          error?.response?.data?.message || "Erro ao atualizar campo!"
        );
      }

      this.removeLoadingToButton("replicarCampoMassaBtn");
    },
    fecharModalReplicacao() {
      this.modoReplicacao = "selecionados";
      this.campoSelecionadoReplicacao = null;
      this.valorCampoReplicacao = null;
      this.produtoOrigemReplicacao = null;
      this.produtosDestinoReplicacao = [];
      this.resultadosLookup = [];
      this.selecionadoItem = null;
      this.actionsStore.selectedRows = [];
      this.$bvModal.hide("replicarCampoMassa");
    },
  },
  computed: {
    ...mapGetters(["layoutConfig", "itsblocked"]),
    config() {
      return this.layoutConfig();
    },
  },
  mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
  },
};
</script>
